var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    clipPath: "url(#clip0_2437_87914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.16658 2.93317H10.1191V2.23343C10.1191 1.88016 9.9742 1.55861 9.74095 1.32536C9.5077 1.09211 9.18615 0.947176 8.83288 0.947176H2.23291C1.87964 0.947176 1.55809 1.09211 1.32483 1.32536C1.09158 1.55861 0.946654 1.88016 0.946654 2.23343V8.8334C0.946654 9.18667 1.09158 9.50822 1.32483 9.74148C1.55809 9.97472 1.87964 10.1197 2.23291 10.1197H2.93265V5.1671C2.93265 4.55228 3.18401 3.99407 3.58822 3.58925C3.99245 3.18446 4.55121 2.93367 5.16608 2.93367L5.16658 2.93317ZM11.0668 2.93317H11.7666C12.3814 2.93317 12.9396 3.18453 13.3444 3.58874C13.7486 3.99297 14 4.55173 14 5.1666V11.7666C14 12.3814 13.7486 12.9396 13.3444 13.3444C12.9396 13.7492 12.3814 14 11.7666 14H5.1666C4.55178 14 3.99356 13.7486 3.58874 13.3444C3.18395 12.9402 2.93317 12.3814 2.93317 11.7666V11.0668H2.23343C1.61861 11.0668 1.0604 10.8155 0.655577 10.4113C0.251352 10.007 0 9.44827 0 8.8334V2.23343C0 1.61861 0.251367 1.0604 0.655577 0.655577C1.06037 0.251352 1.61856 0 2.23343 0H8.8334C9.44822 0 10.0064 0.251367 10.4113 0.655577C10.816 1.06037 11.0668 1.61856 11.0668 2.23343V2.93317ZM11.7666 3.88031H5.1666C4.81333 3.88031 4.49178 4.02524 4.25852 4.2585C4.02527 4.49175 3.88034 4.8133 3.88034 5.16657V11.7665C3.88034 12.1198 4.02527 12.4414 4.25852 12.6746C4.49178 12.9079 4.81333 13.0528 5.1666 13.0528H11.7666C12.1198 13.0528 12.4414 12.9079 12.6746 12.6746C12.9079 12.4414 13.0528 12.1198 13.0528 11.7665V5.16657C13.0528 4.8133 12.9079 4.49175 12.6746 4.2585C12.4414 4.02524 12.1198 3.88031 11.7666 3.88031Z",
    fill: "#767A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_87914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a40b0a52bc24b2369c89a8b69a173319.svg";
export { ForwardRef as ReactComponent };